import React from "react";
import styles from "./StarField.module.scss";

const StarField: React.FC = () => (
  <div className={styles.starField} aria-hidden="true">
    <div className={styles.starsSmall} />
    <div className={styles.starsMedium} />
    <div className={styles.starsLarge} />
    <div className={styles.shootingStar} />
    <div className={styles.shootingStar2} />
  </div>
);

export default StarField;
